export default __webpack_public_path__ + "locales/tr/Webhooks.json?hash=1bd309b2dae325470e41432b8efdcc28";